export default function HarizonAddCandidateIco() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 233 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4740_49599)">
        <rect
          width="233"
          height="120"
          rx="5"
          fill="url(#paint0_linear_4740_49599)"
        />
        <path
          d="M174.5 33.6667H162V21.1667C162 20.0616 161.561 19.0018 160.78 18.2204C159.998 17.439 158.938 17 157.833 17C156.728 17 155.668 17.439 154.887 18.2204C154.106 19.0018 153.667 20.0616 153.667 21.1667V33.6667H141.167C140.062 33.6667 139.002 34.1057 138.22 34.8871C137.439 35.6685 137 36.7283 137 37.8333C137 38.9384 137.439 39.9982 138.22 40.7796C139.002 41.561 140.062 42 141.167 42H153.667V54.5C153.667 55.6051 154.106 56.6649 154.887 57.4463C155.668 58.2277 156.728 58.6667 157.833 58.6667C158.938 58.6667 159.998 58.2277 160.78 57.4463C161.561 56.6649 162 55.6051 162 54.5V42H174.5C175.605 42 176.665 41.561 177.446 40.7796C178.228 39.9982 178.667 38.9384 178.667 37.8333C178.667 36.7283 178.228 35.6685 177.446 34.8871C176.665 34.1057 175.605 33.6667 174.5 33.6667Z"
          fill="white"
        />
        <path
          d="M145.25 123V115.444C145.25 108.403 140.374 102.487 133.775 100.809M120.388 56.0984C125.995 58.3401 129.95 63.7694 129.95 70.1111C129.95 76.4528 125.995 81.8821 120.388 84.1238M126.125 123C126.125 115.959 126.125 112.439 124.96 109.662C123.407 105.959 120.429 103.017 116.68 101.484C113.868 100.333 110.304 100.333 103.175 100.333H91.7C84.5711 100.333 81.0066 100.333 78.1949 101.484C74.446 103.017 71.4675 105.959 69.9146 109.662C68.75 112.439 68.75 115.959 68.75 123M112.738 70.1111C112.738 78.4567 105.887 85.2222 97.4375 85.2222C88.9875 85.2222 82.1375 78.4567 82.1375 70.1111C82.1375 61.7655 88.9875 55 97.4375 55C105.887 55 112.738 61.7655 112.738 70.1111Z"
          stroke="white"
          stroke-width="8.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4740_49599"
          x1="-4.01947e-06"
          y1="5.00001"
          x2="299.5"
          y2="231.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF006A" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <clipPath id="clip0_4740_49599">
          <rect width="233" height="120" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
